import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Port from 'affiliates/Widget/FerrySearchMask/Port';
import DatePickerWrapper from 'affiliates/Widget/FerrySearchMask/DatePickerWrapper';
import SearchButton from 'components/SearchMask/SearchButton';

const tripIndex = 0;

const SingleTrip = ({
  isMobile, loading, isRoundTrip, triedToSubmit, brandLogo, trips, popular, joinProgram, errors, setPort, 
  fetchSuggestions, clearSuggestions, onSuggestionSelected, portString, portStringNo3Ltr, swapPorts,
  setTypeTrip, setDate, setDates, setPortByThreeLetterCode, submitForm, product, translations
}) => {
  const {dep, arr, depSelected, arrSelected, depPopularPorts, arrPopularPorts, obDate, ibDate} = trips[tripIndex];
  const {dep: depTr, arr: arrTr, joinFSAffiliateProgram} = translations;

  return (
    <form className="searchMask">
      <div className="grid no-gutter">
        <div className="destinationInput-wrapper">
          <div className="grid no-gutter">
            <div className="grid-item mb-2 mr-sm-0 mr-3">
              <Port
                type='dep'
                port={dep}
                selected={depSelected}
                className={{
                  input: 'mask-from form-control rounded-0 pr-6',
                  suggestion: 'list-group-item px-3'
                }}
                placeholder={`${depTr}*`}
                tripIndex={tripIndex}
                popular={popular}
                popularPorts={depPopularPorts}
                portString={portString}
                portStringNo3Ltr={portStringNo3Ltr}
                onSuggestionSelected={onSuggestionSelected}
                onChange={setPort}
                fetchSuggestions={fetchSuggestions}
                clearSuggestions={clearSuggestions}
                swapPorts={swapPorts}
                setPortByThreeLetterCode={setPortByThreeLetterCode}
                translations={translations}
              />
              {
                triedToSubmit && errors?.[0]?.dep?.[0] &&
                <div className='searchMask-error'>{errors[0].dep[0]}</div>
              }
            </div>
            <div className="grid-item mb-2">
              <Port
                type='arr'
                port={arr}
                selected={arrSelected}
                className={{
                  input: 'mask-to form-control rounded-0 pr-6',
                  suggestion: 'list-group-item px-3'
                }}
                placeholder={`${arrTr}*`}
                tripIndex={tripIndex}
                popular={popular}
                popularPorts={arrPopularPorts}
                portString={portString}
                portStringNo3Ltr={portStringNo3Ltr}
                onSuggestionSelected={onSuggestionSelected}
                onChange={setPort}
                fetchSuggestions={fetchSuggestions}
                clearSuggestions={clearSuggestions}
                setPortByThreeLetterCode={setPortByThreeLetterCode}
                translations={translations}
              />
              {
                triedToSubmit && errors?.[0]?.arr?.[0] &&
                <div className='searchMask-error'>{errors[0].arr[0]}</div>
              }
            </div>
          </div>
        </div>
        <DatePickerWrapper
          isMobile={isMobile}
          tripIndex={tripIndex}
          roundTrip={isRoundTrip}
          obDate={obDate}
          ibDate={ibDate}
          setRoundTrip={setTypeTrip}
          setDates={setDates}
          setDate={setDate}
          translations={translations}
        />
        <div className="grid no-gutter bottom-aff">
          <div className="grid-item d-flex flex-column justify-content-center">
            <img
              src={brandLogo}
              alt='logo'
              title='logo'
              width='130px'
            />
            {
              joinProgram &&
                <div>
                  <a
                    className="text-small"
                    href="https://ferryscanner.tapfiliate.com/programs/ferryscanner-affiliate-program/signup/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {joinFSAffiliateProgram}    
                  </a>
                </div>
            }
          </div>
          <SearchButton
            loading={loading}
            product={product}
            breakpoint="md"
            submitForm={submitForm}
            translations={translations}
          />
        </div>
      </div>
    </form>
  );
};

SingleTrip.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  isRoundTrip: PropTypes.bool.isRequired,
  triedToSubmit: PropTypes.bool.isRequired,
  product: PropTypes.string.isRequired,
  brandLogo: PropTypes.string.isRequired,
  trips: PropTypes.object.isRequired,
  popular: PropTypes.bool.isRequired,
  joinProgram: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,
  setPort: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  portString: PropTypes.func.isRequired,
  portStringNo3Ltr: PropTypes.func.isRequired,
  swapPorts:PropTypes.func.isRequired,
  setTypeTrip: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  setPortByThreeLetterCode: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    dep: PropTypes.string.isRequired,
    arr: PropTypes.string.isRequired,
    joinFSAffiliateProgram: PropTypes.string.isRequired
  })
};

export default observer(SingleTrip);
